import map from 'lodash/map'
import replace from 'lodash/replace'

export default content => {
  const splitedContent = content.split(/(?=<h1>|<h2>)/)
  return map(splitedContent, c => {
    const titleFormated = c.match(/<h1>.*?<\/h1>|<h2>.*?<\/h2>/g)
    const replacedTitle = titleFormated
      ? replace(titleFormated[0], /<h1>|<\/h1>|<h2>|<\/h2>/g, '')
      : ''
    return {
      title: replacedTitle,
      content: c,
    }
  })
}
